/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Column_Organization_Tooltip2Inputs */

const en_settings_reportingapikeys_column_organization_tooltip2 = /** @type {(inputs: Settings_Reportingapikeys_Column_Organization_Tooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The user's limited partnership, resolved from the auth service. May be unavailable for deleted or GP-owned users.`)
};

/**
* | output |
* | --- |
* | "The user's limited partnership, resolved from the auth service. May be unavailable for deleted or GP-owned users." |
*
* @param {Settings_Reportingapikeys_Column_Organization_Tooltip2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_column_organization_tooltip2 = /** @type {((inputs?: Settings_Reportingapikeys_Column_Organization_Tooltip2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Column_Organization_Tooltip2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_column_organization_tooltip2(inputs)
});
export { settings_reportingapikeys_column_organization_tooltip2 as "settings_reportingApiKeys_column_organization_tooltip" }